import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createStore } from './create-store';

const DEFAULT_DATE_RANGE = [dayjs().subtract(1, 'months'), dayjs()];

export interface ITransportLoadFilter {
  date?: Dayjs[];
  comparisonDate?: Dayjs[];
  userId?: number;
}

type TState = {
  filters: ITransportLoadFilter;
};

type TActions = {
  setFilters: (value: ITransportLoadFilter | undefined) => void;
};

export const useTransportLoadFiltersStore = createStore<TState & TActions>(
  (set) => ({
    filters: { date: DEFAULT_DATE_RANGE },
    setFilters: (filters: ITransportLoadFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'transport-load-filters-store',
);
